import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import { sendEmail } from 'Actions/email';
import CustomFormInput from 'Common/Form/CustomFormInput';
import ButtonLightbox from 'Components/ButtonLightbox/ButtonLightbox';
import ReactQuillInput from 'Common/Form/ReactQuillInput';
import { FormEmailAutocomplete } from 'Common/ReduxForm';
import { isEmailsValidation } from 'Utils';

@connect(store => ({
    loading: store.submissionData.loading,
    usersData: store.userListAutocomplete.data,
}), dispatch => ({
    sendEmail: data => dispatch(sendEmail(data)),
}))
export default class EmailDialog extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        template: PropTypes.object,
        sendEmail: PropTypes.func,
        onSubmit: PropTypes.func,
        submissionId: PropTypes.any,
        openBtnColor: PropTypes.string,
        openBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        openBtnRight: PropTypes.bool,
        openBtnDisabled: PropTypes.bool,
        subject: PropTypes.string,
        to: PropTypes.string,
        parentId: PropTypes.number,
        chooseEmails: PropTypes.bool,
        skipBtn: PropTypes.bool,
        isInitValues: PropTypes.bool,
        initUsers: PropTypes.array,
        usersData: PropTypes.array,
        allowedUsers: PropTypes.array,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        chooseEmails: true,
        skipBtn: true,
        initializedUsers: []
    };

    state = {
        dialogOpen: false,
        body: '',
        subject: '',
        ids: [],
        emails: '',
        emailsError: null
    };

    quillProps = {
        modules: {
            toolbar: [
                [{ 'header': [1, 2, false] }],
                ['bold', 'italic', 'underline','strike'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['clean'],
                ['link']
            ],
        },
        className: 'mail-body-editor'
    };

    componentDidMount() {
        const { template, subject, to, initUsers } = this.props;
        if (template) {
            this.setState({
                body: template.body,
                subject: template.subject
            });
        }

        if (subject) {
            this.setState({subject});
        }

        if (to) {
            this.setState({emails: to});
        }

        if (initUsers) {
            this.setState({ids: initUsers});
        }
    }

    onSubmit(e, isSkip = false) {
        e.preventDefault();
        const { sendEmail, submissionId, parentId, onSubmit } = this.props;
        const { body, ids, emails, subject } = this.state;

        this.setState({
            emailsError: isEmailsValidation(emails)
        }, () => {
            if (!this.state.emailsError) {
                const email = isSkip ? {} : {
                    id: submissionId,
                    body: body,
                    subject: subject,
                    ids: ids,
                    emails: emails,
                    parentId: parentId,
                };

                if (onSubmit && typeof onSubmit === 'function') {
                    onSubmit(email);
                } else {
                    sendEmail(email);
                }

                this.setState({ dialogOpen: false });
            }
        });
    }

    onChangeEmailsSelect(value) {
        this.setState({
            ids: Object.keys(value)
                .filter(key => key !== 'preventDefault')
                .map(key => value[key])
        });
    }

    handleEmailsChange = e => {
        this.setState({
            emails: e.target.value
        });

        const lastChar = e.target.value ? e.target.value.slice(-1) : '';
        if (this.state.emailsError || [' ', ','].includes(lastChar)) {
            this.setState({
                emailsError: isEmailsValidation(e.target.value)
            });
        }
    };

    render() {
        const { openBtnColor, openBtnText, openBtnRight, openBtnDisabled, parentId, chooseEmails, skipBtn, initUsers, isInitValues, allowedUsers } = this.props;
        const { body, ids, emails, subject, dialogOpen, emailsError } = this.state;
        if (isInitValues && !initUsers) return null;

        return (
            <ButtonLightbox
                title={<FormattedMessage id={'title.send_email'}/>}
                text={<FormattedMessage id={chooseEmails ? 'email.text.send' : 'email.text.assign'}/>}
                openBtnText={openBtnText ? openBtnText : <FormattedMessage id={'button.submissions.send_email'}/>}
                openBtnRight={openBtnRight}
                openBtnDisabled={openBtnDisabled}
                submitBtnText={<FormattedMessage id={'button.submissions.submit_send_email'}/>}
                handleSubmit={(e, isSkip) => this.onSubmit(e, isSkip)}
                submitDisabled={!body || (chooseEmails && !ids.length && !emails) || !subject || !!emailsError}
                isOpen={dialogOpen}
                handleClickOpen={() => this.setState({dialogOpen: true})}
                handleClose={() => this.setState({dialogOpen: false})}
                openBtnColor={openBtnColor}
                customClass='email-dialog'
                maxWidth='md'
                skipBtn={skipBtn}
                initialValues={{email_recipients: initUsers}}
            >
                {!parentId && chooseEmails && <Field
                    rowClassName="mm-form-field"
                    name="email_recipients"
                    component={FormEmailAutocomplete}
                    placeholder="email_recipients"
                    onChange={(value) => this.onChangeEmailsSelect(value)}
                    inputProps={{initialValues: initUsers, allowedUsers: allowedUsers}}
                />}
                {chooseEmails && <Field
                    name="email_template_additional"
                    component={ CustomFormInput }
                    type="text"
                    label="email_template_additional"
                    placeholder={'email_template_additional'}
                    input={{value: emails, disabled: !!parentId, onChange: this.handleEmailsChange, error: !!emailsError}}
                    errorText={emailsError}
                    rowClassName='additional-emails-field-wrapper'
                />}
                <Field
                    name="email_template_subject"
                    component={ CustomFormInput }
                    type="text"
                    label="email_template_subject"
                    placeholder="email_template_subject"
                    input={{value: subject, disabled: !!parentId, onChange: (e) => this.setState({subject: e.target.value})}}
                />
                <div className="field-wrapper-textarea">
                    <Field
                        name="email_template"
                        component={ReactQuillInput}
                        className="mail-body-editor"
                        quillProps={this.quillProps}
                        input={{value: unescape(body), onChange: (body) => this.setState({body})}}
                        onBlurSkip
                    />
                </div>
            </ButtonLightbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/containers/EmailDialog.jsx